<div class="h-100">
  @if (isMultiColorActive) {
    <app-color-switcher></app-color-switcher>
  }
  <router-outlet></router-outlet>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate-pulse" fullScreen="true"><p style="color: white">{{ 'loading' | translate}}...</p></ngx-spinner>